/**
 * Redux witness watchers for config
 * @module services/config/watchers
 */
import { GET_CONFIG_DATA, setConfigProcessing, setConfigData } from './redux/actions'
import { getConfig } from '.'

/**
 * Handle getting the config data
 * @param {Object} param0 The parameters
 * @param {Function} param0.after The witness take after function
 */
export function getConfigData ({ after } = {}) {
  return after(GET_CONFIG_DATA, async ({ dispatch, state } = {}) => {
    const { config } = state
    if (config.get('processing') || config.get('data')) {
      return
    }
    try {
      dispatch(setConfigProcessing(true))
      const data = await getConfig()
      dispatch(setConfigData({ data }))
    } catch (e) {
      dispatch(setConfigProcessing(false))
    }
  })
}
